import React from 'react'
import classNames from 'classnames'
import timeout from './../helpers/rAF'
import { compose, lifecycle, withState } from 'recompose'

import CloseButton from './CloseButton'

const Overlay = ({ children, isActive, stillActive, onClose, klassModifier }) => {
  const classes = classNames('modal', { 'modal_active': stillActive }, klassModifier)

  return (
    <div className={classes}>
      <CloseButton className='modal__close-button' onClick={onClose} />

      <div className='modal__body'
        onKeyDown={(e) => {
          (e.which === 27) && onClose()
        }}>
        {(isActive || stillActive) && children}
      </div>
    </div>
  )
}

export default compose(
  withState('stillActive', 'setStill', false),
  lifecycle({
    componentDidMount () {
      if (this.props.isActive && window) {
        window.freezeBody && window.freezeBody()
        this.props.setStill(true)
      }
    },
    componentWillReceiveProps (np) {
      if (this.props.isActive !== np.isActive) {
        if (np.isActive) {
          window.freezeBody()
          this.props.setStill(true)
        } else {
          document.body.classList.add('_animate-close')

          timeout(() => {
            this.props.setStill(false)
            document.body.classList.remove('_animate-close')
          }, 300)

          window.unfreezeBody()
        }
      }
    }
  })
)(Overlay)



// WEBPACK FOOTER //
// ./src/components/Overlay.jsx